import { render, staticRenderFns } from "./DashboardList.vue?vue&type=template&id=09f605e7&scoped=true&"
import script from "./DashboardList.vue?vue&type=script&lang=js&"
export * from "./DashboardList.vue?vue&type=script&lang=js&"
import style0 from "./DashboardList.vue?vue&type=style&index=0&id=09f605e7&prod&lang=scss&scoped=true&"
import style1 from "./DashboardList.vue?vue&type=style&index=1&id=09f605e7&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09f605e7",
  null
  
)

export default component.exports